import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "인허가일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "저장/취급수량", "인허가일", "첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.subInfo.인허가일", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.subInfo.인허가일", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });

    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "공장명",
        key: "body.subInfo.공장명",
      },
      {
        name: "구분1",
        key: "body.subInfo.구분1",
      },
      {
        name: "구분2",
        key: "body.subInfo.구분2",
      },
      {
        name: "시설명",
        key: "body.subInfo.시설명",
      },
      {
        name: "설치위치",
        key: "body.subInfo.설치위치",
      },
      {
        name: "제조/저장/취급수량(㎥)",
        key: "body.subInfo.저장_취급수량",
        style: { minWidth: "150px" },
      },
      {
        name: "인허가일",
        key: "body.subInfo.인허가일",
      },
      {
        name: "첨부",
        key: "body.fileList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).subInfo.공장명; // 공장명
        case 2:
          return func.getContent(value).subInfo.구분1; // 구분1
        case 3:
          return func.getContent(value).subInfo.구분2; // 구분2
        case 4:
          return func.getContent(value).subInfo.시설명; // 시설명
        case 5:
          return func.getContent(value).subInfo.설치위치; // 설치위치
        case 6:
          return func.comma(func.getContent(value).subInfo.저장_취급수량); // 저장/취급수량
        case 7:
          return func.getContent(value).subInfo.인허가일; // 인허가일
        case 8: {
          // 첨부
          const files = func.getContent(value).fileList;
          if (files.length === 0) return "-";
          const latestFile = files[0];
          latestFile.fileName = latestFile.fileName || latestFile.name;
          return {
            type: "docs",
            file: latestFile,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
